import { render, staticRenderFns } from "./InventoryStatusChange.vue?vue&type=template&id=1fb8086f"
import script from "./InventoryStatusChange.vue?vue&type=script&lang=js"
export * from "./InventoryStatusChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports